import axios from 'axios'
import { BUSCAR_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarVeiculo (veiculoId, empresaId) {

    const url = `${URL}/veiculo/${veiculoId}/empresa/${empresaId}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
          type: BUSCAR_VEICULO,
          payload: response
  
        })
    );
  }


